import * as React from 'react';
import type { InjectedFormProps } from 'redux-form';
import { Field } from 'redux-form';

import Input from 'af-fields/Input';

import MultipleOptionsButton from 'af-components/MultipleOptionsButton';
import RectangleButton from 'af-components/MultipleOptionsButton/RectangleButton';
import Tooltip from 'af-components/Tooltip';

import type { EmailContactFM } from './formModel';
import styles from './styles.module.scss';

interface OwnProps extends InjectedFormProps {
	onSubmit: (form: EmailContactFM) => Promise<void>;
	toggleInputEditOff: () => void;
}

type Props = OwnProps;

const EmailForm: React.FC<Props> = (props) => {

	const {
		onSubmit,
		handleSubmit,
		toggleInputEditOff,
	} = props;

	return (
		<div className={styles['email-input-container']}>
			<Field
				autoFocus={true}
				centered={true}
				component={Input}
				hideErrorText={true}
				isStandalone={true}
				name="email"
				placeholder="Enter Email"
				type="text"
			/>
			<MultipleOptionsButton isLeftFlat={true}>
				<RectangleButton
					action={handleSubmit(onSubmit)}
					isLeftOpen={true}
					isSquare={true}
					label={
						<Tooltip message="Submit" >
							<span className="icon-check" />
						</Tooltip>
					}
				/>
				<RectangleButton
					action={toggleInputEditOff}
					isSquare={true}
					label={
						<Tooltip message="Close" >
							<span className="icon-close" />
						</Tooltip>
					}
				/>
			</MultipleOptionsButton>
		</div>
	);
};

export default React.memo(EmailForm);
